import React from 'react'
import {Icon} from '@chakra-ui/react'

const PromoCopyIcon = (props) => {
    return (
        <Icon width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
            <g clipPath="url(#clip0_3835_34990)">
                <path
                    d="M10 4H5C4.44772 4 4 4.44772 4 5V10C4 10.5523 4.44772 11 5 11H10C10.5523 11 11 10.5523 11 10V5C11 4.44772 10.5523 4 10 4Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2 8C1.45 8 1 7.55 1 7V2C1 1.45 1.45 1 2 1H7C7.55 1 8 1.45 8 2"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_3835_34990">
                    <rect width="12" height="12" fill="white" />
                </clipPath>
            </defs>
        </Icon>
    )
}

export default PromoCopyIcon
